import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { SelectionType, TableColumn } from '@swimlane/ngx-datatable';
import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';

import { Material } from '../../../../portfolio/interfaces/material.interface';
import { MaterialsService } from '../../../../portfolio/services/materials.service';
import { NgxDatatablePageEvent, NgxDatatableSelectionEvent } from 'src/app/model/interfaces/ngx-datatable';
import { QueryParams } from 'src/app/model/interfaces/request';
import { ApiResponse } from 'src/app/model/interfaces/response';

@Component({
  selector: 'app-material-modal',
  templateUrl: './material-modal.component.html',
  styleUrls: ['./material-modal.component.css']
})
export class MaterialModalComponent implements OnInit {

  @Output()
  public statusMaterial?: string;
  public onlyActiveP = true;
  private _controlActivo: FormBuilder;

  @ViewChild('btnCloseModal')
  elementBtnCloseModal: ElementRef<HTMLButtonElement>

  @Output()
  onSelect = new EventEmitter<Material>();

  columns: TableColumn[];
  itemsCounts = [25, 50, 100];
  pageSize = this.itemsCounts[0];
  SelectionType = SelectionType;
  selected = [];
  selection?: Material;
  searchParamBehaviorSubject: BehaviorSubject<QueryParams<Material>>;
  dataSource$: Observable<ApiResponse<Material[]>>;
  
  formFilter: FormGroup;

  constructor(
    private readonly _formBuilder: FormBuilder,
    private readonly materialService: MaterialsService,
  ) {
    this.gridColumns();
    this.buildForm();
    this.searchParamBehaviorSubject = new BehaviorSubject({ page: 0, pageSize: this.itemsCounts[0] });
    this.onlyActiveP = true;
  }

  ngOnInit(): void {
    this.dataSource$ = this.searchParamBehaviorSubject
      .asObservable()
      .pipe(
        tap((queryParams)=> this.materialService.queryParams = {...queryParams,
          statusMaterial: this.onlyActiveP==true?'true':'false'}),
        switchMap((queryParams) => this.materialService.findBy()),
    );
    this.formFilter.valueChanges
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
      )
      .subscribe((formValue) => {
        this.searchParamBehaviorSubject.next({ [`${formValue.option}`]: formValue.filter, pageSize: formValue.itemsCount, page: 0 });
    });
  }

  gridColumns() {
    this.columns = [
      {
        name: 'ID Material',
        prop: 'idMaterial',
        width: 150,
        sortable: false,
        draggable: false,
        headerClass: 'fw-bold'
      },
      {
        name: 'Descripcion',
        prop: 'dscaMaterial',
        width: 300,
        sortable: false,
        draggable: false,
        headerClass: 'fw-bold'
      },
      {
        name: 'Tipo Material',
        prop: 'dscaTipoMaterial',
        width: 250,
        sortable: false,
        draggable: false,
        headerClass: 'fw-bold'
      },
      {
        name: 'Grupo',
        prop: 'dscaGrupoArticulo',
        width: 250,
        sortable: false,
        draggable: false,
        headerClass: 'fw-bold'
      },
      {
        name: 'Estado',
        prop: 'statusMaterial',
        width: 100,
      }
    ];
  }
  
  buildForm() {
    this.formFilter = this._formBuilder.group({
      filter: [''],
      option: [this.columns[0].prop],
      itemsCount: [this.itemsCounts[0]],
      orderItems: [false],
      onlyActiveP: this._controlActivo
    });
  }

  onSelectRow($event: NgxDatatableSelectionEvent<Material>) {
    this.selection = $event.selected[0];
  }

  accept() {
    this.onSelect.emit(this.selection);
    this.elementBtnCloseModal.nativeElement.click();
  }

  setPage($event: NgxDatatablePageEvent) {
    this.searchParamBehaviorSubject.next({
      ...this.searchParamBehaviorSubject.value,
      page: $event.offset,
      pageSize: $event.limit
    });
  }

  obtenerTodo() {
    this.dataSource$ = this.searchParamBehaviorSubject
    .asObservable()
    .pipe(
      tap((queryParams)=> this.materialService.queryParams = {...queryParams, 
      statusMaterial: this.onlyActiveP==true?'true':'false'}),
      switchMap((queryParams) => this.materialService.findBy({ statusMaterial: this.onlyActiveP ==true?'true':'false'})),
  );
  }
}
